import type { Locale } from "react-day-picker/locale";
import { resources } from "./index";
import { de, enUS } from "react-day-picker/locale";

export const LANGUAGE2LOCALE: Record<keyof typeof resources, Locale> = {
  en: enUS,
  de: de,
};
